import { render, staticRenderFns } from "./deactivated-users-list.html?vue&type=template&id=07f3deea&scoped=true&external"
import script from "./deactivated-users-list.js?vue&type=script&lang=js&external"
export * from "./deactivated-users-list.js?vue&type=script&lang=js&external"
import style0 from "./deactivated-users-list.scss?vue&type=style&index=0&id=07f3deea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3deea",
  null
  
)

export default component.exports